import React, { Component,Fragment }  from 'react';
import {
    TeamOutlined,SettingOutlined
} from "@ant-design/icons";
import {Menu} from "antd";
import SuperUserList from "./SuperUserList";
import SuperManagerList from "./SuperManagerList";
import {createHashHistory} from "history";
import Header from "../Header";
import SuperSystemManage from "./SuperSystemManage";
import {fetchPost} from "../../static/util/fetch";
const  { SubMenu }  = Menu;
class superMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabBar: 1,
            systemName:'',
        }
    }
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                            systemColor:res.data.systemColor
                        }))
                        if(res.data.systemColor === 1){
                            require([`../../style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`../../styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`../../styleGray.css`], function(list){});
                        }
                    }
                }
            )
    }
    handleChangeTabBar = (tabBar) => {
        this.setState({
            tabBar: tabBar
        })
        switch (tabBar) {
            case 1:
                createHashHistory().push('/superMaster/superuserList')
                break
            case 2:
                createHashHistory().push('/superMaster/superManagerList')
                break
            case 3:
                createHashHistory().push('/superMaster/superSystemManage')
                break
            default:
                break
        }
    }
    render() {
        return(
            <Fragment>
                <Header history={this.props.history}/>
                <div>
                    <Menu
                        className='Navigation'
                        defaultSelectedKeys={["1"]}
                        defaultOpenKeys={['sub0']}
                        mode="inline"
                        theme="light"
                    >
                        <SubMenu
                            key="sub0"
                            align="left"
                            icon={<TeamOutlined style={{fontSize: '20px'}}/>}
                            title="人员管理"
                        >
                            <Menu.Item key="1" onClick={this.handleChangeTabBar.bind(this, 1)}>用户管理</Menu.Item>
                            <Menu.Item key="2" onClick={this.handleChangeTabBar.bind(this, 2)}>管理员管理</Menu.Item>
                        </SubMenu>
                        <Menu.Item key="3" icon={<SettingOutlined style={{fontSize: '20px'}}/>} onClick={this.handleChangeTabBar.bind(this, 3)}>系统管理</Menu.Item>
                    </Menu>
                    <div>
                        {this.state.tabBar === 1 && (
                            <SuperUserList history={this.props.history}/>
                        )
                        }
                        {this.state.tabBar === 2 && (
                            <SuperManagerList history={this.props.history}/>
                        )
                        }
                        {this.state.tabBar === 3 && (
                            <SuperSystemManage history={this.props.history}/>
                        )
                        }
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default superMaster;